import { render } from "./MothersDayOverlay.vue?vue&type=template&id=095e265b&scoped=true"
import script from "./MothersDayOverlay.vue?vue&type=script&lang=js"
export * from "./MothersDayOverlay.vue?vue&type=script&lang=js"

import "./MothersDayOverlay.vue?vue&type=style&index=0&id=095e265b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-095e265b"]])

export default __exports__